import React from 'react';
import HouseIcon from '@mui/icons-material/House';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import useDebugInformation from '../../hooks/useDebugInformation';
import { temp, ui } from '../../interfaces/interfaces';
import { AddressPrefix } from '../../utilities/BasicTypes';
import { AddressUtils } from '../../utilities/address';
import test from '../../utilities/testing';
import { AddressFromAPI } from '../../utilities/address/model';
import { useAppSelector } from "@store/hooks";

const name = "HouseButtonPF"

type Props = {
    tooltip: string;
    prefix: AddressPrefix
    parent: string;
    disabledBtn?: boolean
}

const fetchMergedAddresses = async (prefix: AddressPrefix) => {
    await AddressUtils.mergeAddresses({ prefix, temp, ui })
}

const handleFormPrefill = (prefix: AddressPrefix, parent: string,): void => {
    const {
        organisation_Name,
        building_Name,
        sub_Building_Name,
        building_Number,
        street,
        locality,
        city,
        postcode,
    } = test.addressForm();
    const address = {
        organisation_Name,
        building_Name,
        sub_Building_Name,
        building_Number,
        street,
        locality,
        city,
        postcode,
        isBusiness: organisation_Name ? true : false,
        scope: "Auto-Generated",
    }
    const formData = AddressUtils.mapAddressResourceToFormAddress(address as AddressFromAPI)
    ui[`${prefix}BusinessName`] = formData.BusinessName || "";
    if (prefix !== "CarePlanPlanDetailsAddress") {
        ui[`${prefix}IsBusiness`] = formData.BusinessName ? true : false;
    }
    ui[`${prefix}Property`] = formData.Property || "";
    ui[`${prefix}Street`] = formData.Street || "";
    ui[`${prefix}Locality`] = formData.Locality || "";
    ui[`${prefix}City`] = formData.City || "";
    ui[`${prefix}Postcode`] = formData.Postcode || "";
    ui[`${prefix}Country`] = "United Kingdom";
}

const HouseButtonPF: React.FC<Props> = ({ tooltip, prefix, parent, disabledBtn }) => {
    const addressFormValid = useAppSelector(({ state }) => state[`${prefix}Valid`])
    const length = useAppSelector(({ temp }) => temp[`${prefix}AddressesLength`])

    React.useEffect(() => {
        fetchMergedAddresses(prefix)
    }, [prefix])


    const debugName = `${parent}▷[${name}]`

    const showModal = React.useCallback(() => handleFormPrefill(prefix, parent), [parent, prefix])

    useDebugInformation(debugName, { tooltip, prefix, parent, disabledBtn, addressFormValid, length })
    return (
        <Tooltip title={tooltip ? tooltip : "House"} >
            <span>
                <IconButton onClick={showModal} disabled={disabledBtn ? disabledBtn : false}>
                    <Badge color="primary" invisible={disabledBtn ? disabledBtn : false} >
                        <HouseIcon color={disabledBtn ? "disabled" : "action"} />
                    </Badge>
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default React.memo(HouseButtonPF)